// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","FilterLinks__link":"ce_a bhs_h bhs_kh bhs_we bhs_su bhs_vt bhs_sw bhs_sn"};